/* eslint-disable no-unused-vars */
import { Time, GuideImage, Slots, Ayatan } from "./Assets/Images";

const Links = [
  {
    id: 1,
    name: "BOUNTY SCHEDULER",
    link: "/bountyscheduler",
    image: Ayatan,
    type: "tools",
  },
  // {
  //   id: 2,
  //   name: "WF GUIDES",
  //   link: "/guides",
  //   image: GuideImage,
  //   type: "informative",
  // },
  // {
  //   id: 3,
  //   name: "ROLLING SIMULATOR",
  //   link: "/rolling-simulator",
  //   image: Slots,
  //   type: "games",
  // },
  // {
  //   id: 4,
  //   name: "AYA RNG SIM",
  //   link: "/aya-rng-simulator",
  //   image: Slots,
  //   type: "games",
  // },
];

export default Links;
